export enum ChatType {
  Private = 0,
  Group = 1,
  Comment = 2,
  Mailing = 3,
}
